import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import { ProductOutlined } from '@ant-design/icons';
import FarmerInfos from "./index";
import ViewFarmerInfo from "./view";
import EditFarmerInfo from "./edit";

import farmParcelRoutes from "views/console/farm-parcels/routes";

const farmerRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Farmers",
		basePath: "farmer-informations",
		mainComponent: <FarmerInfos />,
	    layout: "/console",	   
	    icon: <ProductOutlined className="h-6 w-6" />,
	    subTitle:"Farmer Information",
	    viewComponent: <ViewFarmerInfo />,
	    createComponent: <EditFarmerInfo />,
	    editComponent: <EditFarmerInfo />,
		viewSubmodules: [
			...farmParcelRoutes,
		]
		
	})
]

export default farmerRoutes;